import React from 'react';
import { Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';

type InvalidInputErrorProps = {
  isInvalidRow?: boolean;
};

const useStyles = makeStyles((theme) => ({
  invalidInputError: {
    color: '#587CA5'
  },
  errorBanner: {
    backgroundColor: '#DEEEFF',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1, 1.5),
    gap: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    width: 'fit-content',
    marginTop: theme.spacing(3)
  }
}));

const InvalidInputError: React.FC<InvalidInputErrorProps> = ({
  isInvalidRow
}: InvalidInputErrorProps) => {
  const classes = useStyles();
  return (
    <div className={classes.errorBanner} data-testid="collector-settings-error">
      <ErrorIcon className={classes.invalidInputError} color="info" />
      <Typography className={classes.invalidInputError}>
        <FormattedMessage
          id={
            isInvalidRow
              ? 'collectorSetting.isInvalidRow'
              : 'collectorSetting.screentimeError.invalidInput'
          }
        />
      </Typography>
    </div>
  );
};

export default InvalidInputError;
